module.exports = __webpack_public_path__ + "762c4bb83eec4d499143dd379b5b8513.woff";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-semibold-italic.woff
// module id = 78
// module chunks = 0